import React, { useState, useEffect, useRef } from 'react';
import './Publications.css';

const Publications = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const publications = [
    {
      title: "An Accelerated Expectation-Maximization Algorithm for Multi-Reference Alignment",
      authors: "N. Janco and T. Bendory",
      journal: "IEEE Transactions on Signal Processing",
      volume: "vol. 70",
      pages: "pp. 3237-3248",
      year: "2022",
      doi: "10.1109/TSP.2022.3183344",
      ieeeLink: "https://ieeexplore.ieee.org/document/9797053"
    },
    {
      title: "Unrolled Algorithms for Group Synchronization",
      authors: "N. Janco and T. Bendory",
      journal: "IEEE Open Journal of Signal Processing",
      volume: "vol. 4",
      pages: "pp. 424-436",
      year: "2023",
      doi: "10.1109/OJSP.2023.3311354",
      ieeeLink: "https://ieeexplore.ieee.org/document/10237228"
    }
  ];

  return (
    <section id="publications" className="publications" ref={sectionRef}>
      <div className="container">
        <div className={`publications-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">Publications</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">Research papers and academic contributions</p>
        </div>

        <div className={`publications-content ${isVisible ? 'visible' : ''}`}>
          <div className="publications-list">
            {publications.map((pub, index) => (
              <div key={index} className="publication-item">
                <h3 className="publication-title">{pub.title}</h3>
                <p className="publication-authors">{pub.authors}</p>
                <p className="publication-details">
                  {pub.journal}, {pub.volume}, {pub.pages}, {pub.year}
                </p>
                <p className="publication-doi">
                  DOI: <a href={`https://doi.org/${pub.doi}`} target="_blank" rel="noopener noreferrer">{pub.doi}</a>
                </p>
                <p className="publication-ieee">
                  IEEE: <a href={pub.ieeeLink} target="_blank" rel="noopener noreferrer">View on IEEE Xplore</a>
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Publications;